import React, { Component } from 'react';
//import WordSearchHeading from './WordSearchHeading';
import WordSearchStatisticsMultiple from './WordSearchStatisticsMultiple';
//import ReactTooltip from 'react-tooltip'
import ItemHint from './ItemHint';
import ReactTable from "react-table";
import 'react-table/react-table.css'
export default class WordSearchResults extends Component {



  showTheTing = (itemid) => {
  window.open('/just/'+itemid, "_blank", "status=no, menubar=no, width=800,height=800");
  }

  render() {
  const columns = [
    {
    Header: 'DefaultSort',
    id: 'defaultsort',
    accessor: d => d.defaultsort,
    show: false
  },
    {
    Header: 'Line',
    id: 'line',
    width: 300,
    accessor: d => d.linecontent,
    Cell: props => {return <span style={{whiteSpace: "pre"}}  >{props.value}</span>}
  },{
    Header: 'Document',
    id: 'document',
    accessor: d => d.defaultsort,
    Cell: props => {return <a style={{"cursor":"pointer"}} onClick={(() => this.showTheTing(props.original.itemid))}>{props.original.itemheading}</a>}
  },{
    Header: 'Hand',
    id: 'hand',
    accessor: d => d.writers,
    Cell: props => {return <span style={{whiteSpace: "pre"}}>{props.value}</span>}
  },{
    Header: 'Chronology',
    id: 'chronology',
    accessor: d => d.chronology,
    Cell: props => {return <span style={{whiteSpace: "pre"}}>{props.value}</span>}
  },{
    Header: 'Find-area',
    id: 'findarea',
    accessor: d => d.findarea,
    Cell: props => {return <span style={{whiteSpace: "pre"}}>{props.value}</span>}
  },{
    Header: '',
    id: 'content',
    accessor: d => d,
    Cell: props => <div style={{textAlign: 'right'}}><ItemHint data={props.value.itemid}/></div>
  }]


  const defaultSorted=[
            {
              id: "document",
              desc: false
            }
          ];
    return (
      <div className="col-md-12 wordsearchresults">
        <div className="row">
            <div>
            {this.props.isLoading ? <p className="lead">Loading...</p> : this.props.results.statistics?
            <WordSearchStatisticsMultiple data={this.props.results.hits} stats={this.props.results.statistics}  />
            :null}
          </div>



          <div className="panel panel-default">
            <div className="panel-body">
          <ReactTable
          showPagination={false}
          loading = {this.props.isLoading}
          pageSize={this.props.results.hits !== undefined ? this.props.results.hits.length: 1}
          minRows={1}
          data={this.props.results.hits}
          columns={columns}
          defaultSorted={defaultSorted}
          className="-striped -highlight"
/>

        </div>
      </div>

      </div>
    </div>
  )
  }
}



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/WordSearchResults.jsx